import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------general page api's-------------------------------->
    getState(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/general/state')
    },
    getPaymentmethod(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/general/paymentmethod')
    },
    // save custom filter
    postcustomfilter(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/addcustomfilter', data)
    },
    deletecustomfilter(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/deletecustomfilter', data)
    },
    getallcustomfilter(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/getallcustomfilter', data)
    },
    postReceipt(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/receipt', data)
    },
    gettaglist(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/general/taglist')
    },
    getOrderStatus(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/general/OrderStatus')
    },
    getQuotStatus(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/general/QuotStatus')
    },
    getCountry(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/general/country')
    },
    getTax(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/general/tax')
    },
    getSalesAccount(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/general/SalesAccount')
    },
    postTag(tag_name, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/TagCreate', tag_name)
    },
    getCustomerData(val, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/general/customerSearch/' + val)
    },
    postCustomerAdvanceSearchDatas(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/customerAdvanceSearch', data)
    },
    getProductData(val, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/productSearch', val)
    },
    postSalesPerson(field, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/SalespersonCreate', field)
    },
    /**
     * sales person delete
     */
    SalPersonDelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/SalesPersonDelete', id)
    },
    /**
     * sales person delete
     */
    SalProjectDelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/PjtTagDelete', id)
    },
    /**
     * sales tag delete
     */
    SalTagDelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/SalTagDelete', id)
    },
    /**
     * pdt tag delete
     */
    PdtTagDelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/PdtTagDelete', id)
    },
    /**
     * cus tag delete
     */
    CusTagDelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/CusTagDelete', id)
    },
    /**
     * 
     * @param {*} field 
     */
    //project api's
    postProject(field, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/project/create', field)
    },

    /**
     * get status list
     */
    getStatus(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/general/statusmethod')
    },
    postCustomerInvoiceDetails(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/invoiceidsmethod', id)
    },
    /**
     * get reponse of availabe invoice of particular retainer
     * @param {*} data 
     */
    postretainerinvoiceavailable(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/retainerlist', data)
    },
    postpaymentinvoiceavailable(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/paymentlist', data)
    },
    /**
     * get reponse of availabe invoice of particular retainer
     * @param {*} data 
     */
    postcreditinvoiceavailable(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/creditlist', data)
    },
    /**
     * handling the available retaienr to be used to pay the invoice due amount api
     * @param {*} data 
     */
    postUnusedRetainerUpdate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/creditsapplied/invretaineramount', data)
    },
    /**
     * handling the available retaienr to be used to pay the invoice due amount api
     * @param {*} data 
     */
    postUnusedCreditUpdate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/creditsapplied/invcreditamount', data)
    },
    /**
     * get reponse of availabe invoice of particular customer advance
     * @param {*} data 
     */
    postcustomeradvanceinvoiceavailable(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/customeradvancelist', data)
    },
    /**
     * handling the available customer advance to be used to pay the invoice due amount api
     * @param {*} data 
     */
    postUnusedCustomerAdvanceUpdate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/creditsapplied/cusadvamount', data)
    },
    /**
     * handling the available payment invoice to be used to pay the invoice due amount api
     * @param {*} data 
     */
    postUnusedPaymentInvoiceUpdate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/creditsapplied/pymntinvamount', data)
    },
    postautogeneratecode(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/autogeneratecode', data)
    },
    postexempt(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/ExemptReasonCreate', data)
    },
    exemptdelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/ExemptReasonDelete', id)
    },
    getexemptdelete(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/CusExemptReasonDelete', id)
    },
    /**
     * get price list detail from product id
     */
    getpricelistrate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/pricelistrate', data)
    },
    // update migration date
    updatemigrationdate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/openingbalance/update', data)
    },

    postexemptreason(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/CusExemptReasonCreate', data)
    },
}